import $ from 'jquery';

$(document).ready(() => {
    function slider_sem() {
        $('.slider-seminaire').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            appendArrows: $('.digital .custom-arrows'),
            nextArrow: '<div class="next-item">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">\n' +
                '    <g fill="none" fill-rule="evenodd">\n' +
                '        <g>\n' +
                '            <g>\n' +
                '                <g transform="translate(-1117 -1652) translate(45 1298) translate(1072 354)">\n' +
                '                    <rect width="38" height="38" fill="#E40273" rx="2"/>\n' +
                '                    <path fill="#FFF" d="M28.188 17.615l-5.17-5.229c-.51-.515-1.335-.515-1.845 0-.507.515-.507 1.35 0 1.865l3.33 3.364h-14.2c-.72 0-1.303.59-1.303 1.318 0 .729.584 1.319 1.304 1.319h14.198l-3.33 3.364c-.506.515-.506 1.35 0 1.864.256.258.592.387.925.387.333 0 .667-.129.922-.387l5.169-5.228c.541-.54.812-.98.812-1.319 0-.338-.27-.778-.812-1.318z"/>\n' +
                '                </g>\n' +
                '            </g>\n' +
                '        </g>\n' +
                '    </g>\n' +
                '</svg>' +
                '</div>',
            prevArrow: '<div class="prev-item">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">\n' +
                '    <g fill="none" fill-rule="evenodd">\n' +
                '        <g>\n' +
                '            <g>\n' +
                '                <g transform="translate(-1059 -1652) translate(45 1298) translate(1014 354) matrix(-1 0 0 1 38 0)">\n' +
                '                    <rect width="38" height="38" fill="#CCC" rx="2"/>\n' +
                '                    <path fill="#FFF" d="M28.188 17.615l-5.17-5.229c-.51-.515-1.335-.515-1.845 0-.507.515-.507 1.35 0 1.865l3.33 3.364h-14.2c-.72 0-1.303.59-1.303 1.318 0 .729.584 1.319 1.304 1.319h14.198l-3.33 3.364c-.506.515-.506 1.35 0 1.864.256.258.592.387.925.387.333 0 .667-.129.922-.387l5.169-5.228c.541-.54.812-.98.812-1.319 0-.338-.27-.778-.812-1.318z"/>\n' +
                '                </g>\n' +
                '            </g>\n' +
                '        </g>\n' +
                '    </g>\n' +
                '</svg>' +
                '</div>',
            responsive: [
                {
                    breakpoint: 921,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 766,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    }
                },
            ]
        });
    }
    slider_sem()

    $('.digital .modal').each(function () {
        let iframe = $(this).find('iframe');
        $(this).on('shown.bs.modal', function () {
            // iframe.attr("src", iframe.attr('src') +"&amp;autoplay=1");
        });
        $(this).on('hidden.bs.modal', function () {
            iframe.attr('src', iframe.attr('src'));
        });
    });

    function slider_vids() {
        $('.slider-vids').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            appendArrows: $('.vids .custom-arrows'),
            nextArrow: '<div class="next-item">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">\n' +
                '    <g fill="none" fill-rule="evenodd">\n' +
                '        <g>\n' +
                '            <g>\n' +
                '                <g transform="translate(-1117 -1652) translate(45 1298) translate(1072 354)">\n' +
                '                    <rect width="38" height="38" fill="#E40273" rx="2"/>\n' +
                '                    <path fill="#FFF" d="M28.188 17.615l-5.17-5.229c-.51-.515-1.335-.515-1.845 0-.507.515-.507 1.35 0 1.865l3.33 3.364h-14.2c-.72 0-1.303.59-1.303 1.318 0 .729.584 1.319 1.304 1.319h14.198l-3.33 3.364c-.506.515-.506 1.35 0 1.864.256.258.592.387.925.387.333 0 .667-.129.922-.387l5.169-5.228c.541-.54.812-.98.812-1.319 0-.338-.27-.778-.812-1.318z"/>\n' +
                '                </g>\n' +
                '            </g>\n' +
                '        </g>\n' +
                '    </g>\n' +
                '</svg>' +
                '</div>',
            prevArrow: '<div class="prev-item">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">\n' +
                '    <g fill="none" fill-rule="evenodd">\n' +
                '        <g>\n' +
                '            <g>\n' +
                '                <g transform="translate(-1059 -1652) translate(45 1298) translate(1014 354) matrix(-1 0 0 1 38 0)">\n' +
                '                    <rect width="38" height="38" fill="#CCC" rx="2"/>\n' +
                '                    <path fill="#FFF" d="M28.188 17.615l-5.17-5.229c-.51-.515-1.335-.515-1.845 0-.507.515-.507 1.35 0 1.865l3.33 3.364h-14.2c-.72 0-1.303.59-1.303 1.318 0 .729.584 1.319 1.304 1.319h14.198l-3.33 3.364c-.506.515-.506 1.35 0 1.864.256.258.592.387.925.387.333 0 .667-.129.922-.387l5.169-5.228c.541-.54.812-.98.812-1.319 0-.338-.27-.778-.812-1.318z"/>\n' +
                '                </g>\n' +
                '            </g>\n' +
                '        </g>\n' +
                '    </g>\n' +
                '</svg>' +
                '</div>',
            responsive: [
                {
                    breakpoint: 921,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 766,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    }
                },
            ]
        });
    }
    slider_vids()

    $('.vids .modal').each(function () {
        let iframe = $(this).find('iframe');
        $(this).on('shown.bs.modal', function () {
            // iframe.attr("src", iframe.attr('src') +"&amp;autoplay=1");
        });
        $(this).on('hidden.bs.modal', function () {
            iframe.attr('src', iframe.attr('src'));
        });
    });
})

